/**
 * German labels for configurable pages and overview columns. Keys MUST match
 * the backend DEFAULTS in app/services/module_visibility.py and column_config.py.
 * Shared by the admin config tabs (CityDetail) and the list column guards.
 */

/** Untertitel der Anwendung — einzige Quelle für alle Anzeigestellen. */
export const APP_TAGLINE = 'Kommunale Plattform für Kurzzeitvermietung und Wohnraumschutz';

export const MODULE_LABELS: Record<string, string> = {
  dashboard: 'Dashboard',
  aufgaben: 'Aufgaben',
  karte: 'Karte',
  bebauungsplaene: 'Bebauungspläne',
  anfragen: 'Anfragen',
  verfahren: 'Verfahren',
  inserate: 'Inserate',
  adressen: 'Adressen',
  haeuser: 'Häuser',
  objekte: 'Objekte',
  vermieter: 'Vermieter',
  gruppen: 'Gruppen',
  daten: 'Daten',
};

/**
 * List-view path per module key. Order matches the sidebar; used to pick a
 * fallback redirect target ("first enabled module") when a disabled one opens.
 */
export const MODULE_PATHS: Record<string, string> = {
  dashboard: '/dashboard',
  aufgaben: '/aufgaben',
  karte: '/karte',
  bebauungsplaene: '/bebauungsplaene',
  anfragen: '/anfragen',
  verfahren: '/verfahren',
  inserate: '/inserate',
  adressen: '/adressen',
  haeuser: '/haeuser',
  objekte: '/objekte',
  vermieter: '/vermieter',
  gruppen: '/gruppen',
  daten: '/daten',
};

/** Entities that expose the documents feature (config keys), with labels. */
export const DOCUMENT_ENTITY_LABELS: Record<string, string> = {
  inserat: 'Inserate',
  verfahren: 'Verfahren',
  anfrage: 'Anfragen',
  adresse: 'Adressen',
  bebauungsplan: 'Bebauungspläne',
};

export const DOCUMENT_ACTION_LABELS: Record<string, string> = {
  tab: 'Reiter „Dokumente" sichtbar',
  upload: 'Hochladen erlaubt',
  create: 'Aus Vorlage erstellen erlaubt',
};

export const COLUMN_LABELS: Record<string, { label: string; columns: Record<string, string> }> = {
  inserate: {
    label: 'Inserate',
    columns: {
      address: 'Adresse',
      zipcode: 'PLZ',
      platform: 'Plattform',
      state: 'Status',
      vermieter: 'Vermieter',
      verfahren: 'Verfahren',
    },
  },
  verfahren: {
    label: 'Verfahren',
    columns: {
      status: 'Status',
      vermieter: 'Vermieter',
      adresse: 'Adresse',
      inserate: 'Inserate',
      zustaendig: 'Zuständig',
      frist: 'Frist',
    },
  },
  anfragen: {
    label: 'Anfragen',
    columns: {
      status: 'Status',
      zuordnung: 'Zuordnung',
      notizen: 'Notizen',
      created_at: 'Erstellt',
    },
  },
  adressen: {
    label: 'Adressen',
    columns: {
      plz: 'PLZ',
      stadt: 'Stadt',
      haeuser: 'Häuser',
      verfahren: 'Verfahren',
    },
  },
  haeuser: {
    label: 'Häuser',
    columns: {
      adresse: 'Adresse',
      plz: 'PLZ',
      baugenehmigung: 'Baugenehmigung',
      objekte: 'Objekte',
      verfahren: 'Verfahren',
    },
  },
  objekte: {
    label: 'Objekte',
    columns: {
      typ: 'Typ',
      haus: 'Haus',
      adresse: 'Adresse',
      plz: 'PLZ',
      verfahren: 'Verfahren',
      inserate: 'Inserate',
    },
  },
  vermieter: {
    label: 'Vermieter',
    columns: {
      typ: 'Typ',
      email: 'E-Mail',
      telefon: 'Telefon',
      inserate: 'Inserate',
      verfahren: 'Verfahren',
    },
  },
};
